import React from 'react';
import Skeleton from './Skeleton';

/**
 * TabSkeleton
 * Generic shimmer placeholder for a client-details tab (header + section cards
 * with field placeholders). Bare (no outer page card) so it nests inside a
 * tab's existing wrapper.
 */

const S = Skeleton;

const Section = () => (
  <div className="rounded-xl border border-[#E5EAF3] dark:border-gray-800 bg-white dark:bg-[#262b33] p-5 space-y-4">
    <S className="h-3.5 w-40 rounded-md" />
    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-5">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="space-y-2">
          <S className="h-2.5 w-16 rounded" />
          <S className="h-3.5 w-24 rounded" />
        </div>
      ))}
    </div>
  </div>
);

const TabSkeleton = ({ sections = 2 }) => (
  <div className="space-y-5">
    <div className="flex items-center justify-between">
      <S className="h-5 w-40 rounded-md" />
      <div className="flex gap-2">
        <S className="h-8 w-24 rounded-lg" />
        <S className="h-8 w-24 rounded-lg" />
      </div>
    </div>
    {Array.from({ length: sections }).map((_, i) => <Section key={i} />)}
  </div>
);

export default TabSkeleton;
